import React, { useState } from "react";
import { Image, Button, Icon, Confirm } from "semantic-ui-react";
import { image } from "../../../../../assets";
import { InstitutionApi } from "../../../../../api";
import { useAuth } from "../../../../../hooks";
import { BasicModal } from "../../../../Shared";
import { InstitutionForm } from "../InstitutionForm";
import "./InstitutionItem.scss";

const institutionController = new InstitutionApi();

export function InstitutionItem(props) {
  const { institution, onReload } = props;
  const { accessToken, user } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [isDelete, setIsDelete] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const onOpenUpdateUser = () => {
    setTitleModal(`Actualizar ${institution.institutionnam}`);
    onOpenCloseModal();
  };

  const onActivateDeactivate = async () => {
    try {
      await institutionController.updateInstitutionActive(
        accessToken,
        institution._id,
        {
          active: !institution.active,
        },
      );
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const openDeactivateActivateConfirm = () => {
    setIsDelete(false);
    setConfirmMessage(
      institution.active
        ? `Desactivar institución ${institution.institutionnam}`
        : `Activar institución ${institution.institutionnam}`,
    );
    onOpenCloseConfirm();
  };

  const openDeleteConfirm = () => {
    setIsDelete(true);
    setConfirmMessage(`Eliminar institución ${institution.institutionnam}`);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await institutionController.deleteInstitution(
        accessToken,
        institution._id,
      );
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      {institution.active ? (
        <div className="institution-item">
          <div className="institution-item__image">
            <img
              src={
                institution.avatar ? `${institution.avatar}` : image.noAvatar
              }
              alt={institution.institutionnam}
              loading="lazy"
            />
          </div>
          <div className="institution-item__content">
            <h2>{institution.institutionnam}</h2>
            <p>Dirección : {institution.address}</p>
            <p>Tlf : {institution.phone}</p>
            <p>Estudiantes : {institution.studentsnum}</p>
            <p>Docentes : {institution.teachersnum}</p>
            <p>Licencia : {institution.plan}</p>
            <p>{institution.website}</p>
            <div className="institution-item__buttons">
              <Button icon as="a" href={institution.website} target="_blank">
                <Icon name="eye" />
              </Button>
              <Button icon primary onClick={onOpenUpdateUser}>
                <Icon name="pencil" />
              </Button>
              <Button icon color="red" onClick={openDeleteConfirm}>
                <Icon name="trash" />
              </Button>
            </div>
          </div>
        </div>
      ) : (
        // Diseño original para instituciones inactivas
        <div className="institution-item">
          <div className="institution-item__info">
            <Image
              avatar
              src={
                institution.avatar ? `${institution.avatar}` : image.noAvatar
              }
            />
            <div>
              <p>
                {institution.firstname} {institution.lastname}
              </p>
              <p>{institution.email}</p>
            </div>
          </div>
          <div>
            <Button icon primary onClick={onOpenUpdateUser}>
              <Icon name="pencil" />
            </Button>
            <Button
              icon
              color={institution.active ? "orange" : "teal"}
              onClick={openDeactivateActivateConfirm}
            >
              <Icon name={institution.active ? "ban" : "check"} />
            </Button>
            <Button icon color="red" onClick={openDeleteConfirm}>
              <Icon name="trash" />
            </Button>
          </div>
        </div>
      )}

      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal}>
        <InstitutionForm
          close={onOpenCloseModal}
          onReload={onReload}
          institution={institution}
          user={user}
        />
      </BasicModal>
      <Confirm
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={isDelete ? onDelete : onActivateDeactivate}
        content={confirmMessage}
        size="mini"
      />
    </>
  );
}
